import type { PayloadAction } from '@reduxjs/toolkit';
import type { ModalsState, UpdateVisibilityPayload } from 'src/types/modals';

const reducers = {
  updateVisibility: (state: ModalsState, action: PayloadAction<UpdateVisibilityPayload>) => {
    state[action.payload.modalType].isVisible = action.payload.isVisible;
    state[action.payload.modalType].extraProps = action.payload.extraProps || {};
  },
};

export default reducers;
